module.exports = __webpack_public_path__ + "img/swipe (6).decdf29b.jpg";